import { useWallet } from '@solana/wallet-adapter-react'
import { FC } from 'react'
import { Button } from '@mui/material'
import { useDispatch } from 'react-redux'
import { setOpenLoanModal } from '../../redux/modules/loans'

export const OpenLoanButton: FC = () => {
  const { publicKey } = useWallet()
  const dispatch = useDispatch()
  const handleOpen = () => dispatch(setOpenLoanModal(true))

  return (
    <div>
      <Button
        className="Open-loan-button"
        onClick={handleOpen}
        disabled={!publicKey}
        variant={'contained'}
      >
        Open New Loan
      </Button>
    </div>
  )
}
